import { AgreementChangeType } from './model';
export function servicesChange(changes) {
    return changes.find((ch)=>ch.type === AgreementChangeType.Services);
}
export function serviceQboClassChanges(changes) {
    return changes.filter((ch)=>ch.type === AgreementChangeType.ServiceQboClass);
}
